<template>
  <div class="container">
    <div class="large-12 medium-12 small-12 cell">
      <label
        >File
        <input
          type="file"
          id="file"
          ref="file"
          v-on:change="handleFileUpload()"
        />
      </label>
      <button v-on:click="submitFile()">Отправить</button>
      <div v-if="uploaded">Файл успешно загружен
        <button @click="">Сохранить</button>
      </div>
      <div v-if="loaded">Успешно обработано {{ loaded }} собственников</div>
      <div class="upload_errors">
        <div v-if="has_errors" @click="errors_collapsed = !errors_collapsed">
          Ошибок обработки файла: {{ errors.length }}
        </div>
        <div class="upload_errors_container" v-if="!errors_collapsed">
          <div v-for="error in errors" :key="error">{{ error }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "upload-template-file",
  data() {
    return {
      url: config.backend_url,
      file: "",
      loaded: 0,
      errors_collapsed: true,
      has_errors: false,
      errors: [],
      uploaded: false
    };
  },

  methods: {
    submitFile() {
      let formData = new FormData();

      formData.append("file", this.file);

      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "plots/parse-xls/",
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data"
          },
          formData: formData
        })
        .then(response => {
          //self.errors = Object.values(response.data.errors);
          //self.loaded = response.data.loaded;
          //self.has_errors = self.errors.length > 0;
          this.$emit("uploadComplite", response);
          self.uploaded = true;
        })
        .catch(() => console.log("error occured"));
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    }
  }
};
</script>
